import React from "react";
import { usePagination, DOTS } from "../hooks/usePagination";

const Pagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
  className = "",
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => onPageChange(currentPage + 1);
  const onPrevious = () => onPageChange(currentPage - 1);
  const lastPage = paginationRange[paginationRange.length - 1];
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === lastPage;

  return (
    <div className={className}>
      <nav
        className="flex items-center justify-center gap-2 bg-gray-100 rounded-full py-2 w-fit mx-auto"
        aria-label="Pagination"
      >
        <button
          type="button"
          onClick={onPrevious}
          disabled={isFirstPage}
          className="flex items-center justify-center w-10 h-10 rounded-full text-[#3D3B40] hover:bg-gray-200/80 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
          aria-label="Previous page"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <div className="flex items-center gap-2 mx-1">
          {paginationRange.map((pageNumber, index) => {
            if (pageNumber === DOTS) {
              return (
                <span
                  key={`dots-${index}`}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-white border border-gray-200 text-[#3D3B40] text-sm font-medium shadow-sm"
                >
                  &#8230;
                </span>
              );
            }

            const isActive = pageNumber === currentPage;
            return (
              <button
                key={index}
                type="button"
                onClick={() => onPageChange(pageNumber)}
                className={`flex items-center justify-center w-10 h-10 rounded-full text-sm font-medium transition-colors ${isActive
                  ? "bg-[#2563EB] text-white shadow-sm"
                  : "bg-white text-[#3D3B40] border border-gray-200 shadow-sm hover:bg-gray-50"
                  }`}
                aria-label={isActive ? `Page ${pageNumber}` : `Go to page ${pageNumber}`}
                aria-current={isActive ? "page" : undefined}
              >
                {pageNumber}
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={onNext}
          disabled={isLastPage}
          className="flex items-center justify-center w-10 h-10 rounded-full text-[#3D3B40] hover:bg-gray-200/80 disabled:opacity-40 disabled:hover:bg-transparent transition-colors"
          aria-label="Next page"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </nav>
      {/* <p className="mt-4 text-sm text-[#726E75] text-center">
        Viewing {(currentPage - 1) * pageSize + 1}–
        {Math.min(currentPage * pageSize, totalCount)} of {totalCount} properties
      </p> */}
    </div>
  );
};

export default Pagination;
